import React from "react";
import "./Blog.css";

const Blog = () => {
  return (
    <div className="blog-container">
      <h1>Bienvenue sur le Blog</h1>
      <p>Articles, actualités et nouveautés.</p>
    </div>
  );
};

export default Blog;
